module.exports = __webpack_public_path__ + "static/media/subscription-selected.f674d948.svg";